import { useTranslation } from 'react-i18next';
import {
  ClientesPorStatus,
  TempoMedio,
  calcularTotalClientes,
  calcularTaxaConversao,
  calcularTempoMedioGeral,
  calcularClientesAguardando,
} from '@/types/dashboard';

interface CardsResumoProps {
  dadosStatus: ClientesPorStatus[];
  dadosTempo: TempoMedio[];
}

interface MetricCardProps {
  titulo: string;
  valor: string | number;
  subtitulo?: string;
}

function MetricCard({ titulo, valor, subtitulo }: MetricCardProps) {
  return (
    <div className="bg-card border border-border rounded-2xl shadow-sm">
      <div className="p-5 min-h-[120px] flex flex-col justify-between gap-3">
        <p className="text-[11px] uppercase tracking-wider font-semibold text-muted-foreground">
          {titulo}
        </p>
        <p className="text-4xl font-bold tabular-nums leading-none text-foreground">
          {valor}
        </p>
        {subtitulo && (
          <p className="text-[11px] text-muted-foreground">{subtitulo}</p>
        )}
      </div>
    </div>
  );
}

export function CardsResumo({ dadosStatus, dadosTempo }: CardsResumoProps) {
  const { t } = useTranslation();
  const totalClientes = calcularTotalClientes(dadosStatus);
  const taxaConversao = calcularTaxaConversao(dadosStatus);
  const tempoMedio = calcularTempoMedioGeral(dadosTempo);
  const aguardando = calcularClientesAguardando(dadosStatus);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <MetricCard
        titulo={t('dashboard.cards.totalClients')}
        valor={totalClientes}
        subtitulo={t('dashboard.cards.totalClientsSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.conversionRate')}
        valor={`${taxaConversao}%`}
        subtitulo={t('dashboard.cards.conversionRateSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.averageTime')}
        valor={`${tempoMedio}h`}
        subtitulo={t('dashboard.cards.averageTimeSubtitle')}
      />
      <MetricCard
        titulo={t('dashboard.cards.waiting')}
        valor={aguardando}
        subtitulo={t('dashboard.cards.waitingSubtitle')}
      />
    </div>
  );
}

export { MetricCard };
